<template>
	<!-- <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div>
  -->
	<div v-if="!is_login">
		<router-view />
	</div>
	
	<el-container v-else style="min-height: 100vh; border: 1px solid #eee">
		<div id="menu">
			<el-menu
				:style="{width: (!isCollapse? 150: 63 )+ 'px'}"
				:collapse="isCollapse" unique-opened @select="selectMenu"
				:collapse-transition="false"
			>
			<el-menu-item-group
				v-for="(item, index) in routerList" :key="index"
			>
				<el-menu-item class="flex alignC" :index="`${item.url}`" :class="item.is_check?'is-select':''">
					<img :src="item.is_check ? item.checked_icon : item.icon" />
					{{!isCollapse?item.name:''}}
				</el-menu-item>
			</el-menu-item-group>
			</el-menu>
		</div>
		<el-container>
			<el-header class="bg-ff header" style="padding: 0;left: 0;position: fixed;right: 0;top: 0;z-index: 999;">
				<div class="flex alignC">
					<div class="text-center logo" :style="{height: '64px',width: (!isCollapse? 150: 63 )+ 'px'}">
						<a href="/#">
							<img v-if="isCollapse" class="thumb" src="@/assets/img/logo@2x.png" />
							<img v-if="!isCollapse" class="full" src="@/assets/img/logo.png" />
						</a>
					</div>
					<div class="flex flex-1 alignC" style="padding: 0 20px;">
						<div class="folda relative" @click="collapse">
							<img src="./assets/img/ri-menu-2-line.png" style="">
						</div>
						<div class="f-18 mar-l-12">
							{{userinfo.store_name}}
						</div>
						<div class="flex-1 flex flexR alignC" >
                            <el-button type="warning" icon="el-icon-message" @click="messageClick" round >{{number}}</el-button>

							<el-dropdown>
								<div class="flex alignC">
									<!-- <img class="wh-24" style="border-radius: 100%" :src="userinfo.picture" alt=""> -->
									<div class="f-18 mar-l-8 mar-r-10">{{userinfo.nickname}}({{userinfo.name}})</div>
									<i class="el-icon-arrow-down f-18"></i>
								</div>
								<template #dropdown>
									<el-dropdown-menu>
										<el-dropdown-item @click="logout">退出登录</el-dropdown-item>
									</el-dropdown-menu>
								</template>
							</el-dropdown>
						</div>
					</div>
				</div>

			</el-header>

			<el-main id="main" class="bg-f2" :style="{marginTop: '64px', marginLeft: (!isCollapse? 150: 63 )+ 'px'}">
				<div class="main-header">
						<div class="main-tabar">
							<el-menu class="el-menu-demo" mode="horizontal" @select="selectTabbar">
							  <el-menu-item v-for="(item,index) in tabbarList" :index="index.toString()" :class="item.is_check?'is-select':''">{{item.name}}</el-menu-item>
							</el-menu>
						</div>
					<router-view />
				</div>
			</el-main>
		</el-container>
	</el-container>
</template>
<script>
	import {
		ref,
		defineComponent,
		inject
	} from "vue";
	// import NavMenu from "@/components/NavMenu/NavMenu.vue";
	// import Header from "@/components/Header.vue";
	import RouterList from "./NavMenu";
	import { storeRouter } from "@/store/Router";
	import { Request } from "@/api/request";
	import { postLogout,scheduleDataConfig } from "@/api/http";
	export default defineComponent({
		name: "App",
		components: {},
		provide() {
			return {
				headClass: this.headClass,
				setTitle: this.setTitle,
				loginStatusChange: this.loginStatusChange,
				_option: this._option
			};
		},
		mounted() {
			// // 侧边导航栏需与权限路由保持一致
			// let routerList = storeRouter.getRouter(),
			//     router:any = [];
			// routerList.forEach((item: any) => {
			//     this.RouterList.forEach((items) => {
			//         let nav: any = {};
			//         if (item.path == items.path) {
			//             nav = {...items};
			//             let children = [];
			//             if (items.children) {
			//                 nav.children = []
			//                 item.children.forEach((children: any) => {
			//                     nav.children.push(
			//                         items.children.filter(
			//                             (data: any) => data.path == children.path
			//                         )[0]
			//                     );
			//                 });
			//             }
			//             router.push(nav)
			//         }
			//     });
			// });
			// this.RouterList = router

			// 初始化导航栏索引
			Request.axiosInstance({
				url: "adminapi/Privilege/list",
				data: {
					type:1,
				},
			}).then((res) => {
				this.routerList = res?.content?.list || [];
				this.selectMenu(this.$route.path)
			});
			
			let path = window.location.href.split("#/")[1],
				father = `/${path.split("/")[0]}`,
				children = path.split("/")[1];
			if (!path) return;
		},
		data() {
			return {
			    number:0,
				isCollapse: false,
				title: [''],
				childrenTitle: "",
				is_login: false,
				routerList:[],
				tabbarList:[],
				active: 0,
				userinfo: {},
			};
		},
		watch: {
			$route() {
				var _this = this;
				var routename =  _this.$route.name;
                if (routename == 'Billing'){
                    scheduleDataConfig({}).then((res)=>{
                        this.number = res.content.count;
                    });
                }
                console.log("这里执行了",_this.$route.name);
				var user_info = localStorage.getItem('user_info')
				if(!_this.is_login && !_this.user_info) //第一次登陆
				{
					_this.userinfo = JSON.parse(localStorage.getItem('user_info'))
				}
				_this.is_login = !(routename == "Login")
				if(!_this.is_login)
					localStorage.removeItem('user_info')
			},
		},
		methods: {
            messageClick(){
                this._option('/customer/schedule/index');
            },
			collapse() {
				this.isCollapse = !this.isCollapse;
			},
			headClass() {
				return "background-color: #f2f5f9;";
			},
			setTitle(title) {
				this.title = title;
			},
			loginStatusChange(status) {
				this.is_login = status;
			},
			selectMenu(path) {
				let parentActiveIndex = -1;
				for (let idx in this.routerList) {
					// 重置左侧菜单为待选中状态
					this.routerList[idx].is_check = false;
					// 遍历子菜单
					for (let i in this.routerList[idx].children){
						// 找到当前激活的子菜单
						if(this.routerList[idx].children[i].path == path){
							// 标记当前顶部子菜单所属父级激活菜单
							parentActiveIndex = idx;
							// 将父级菜单标记为高亮选中状态
							this.routerList[idx].is_check = true;
							// 设置要展示的子菜单到顶部
							this.tabbarList = this.routerList[idx].children;
						}
					}
					// 若当前访问路由是子级菜单，则高亮左侧父级菜单，并展示该父级菜单下所有子菜单，高亮对应路由子菜单
					if(parentActiveIndex == idx){
						// 遍历子菜单
						for (let i in this.tabbarList){
							// 重置顶部子菜单为待选中状态
							this.tabbarList[i].is_check = false;
							// 找到当前激活的子菜单
							if(this.routerList[idx].children[i].path == path){
								// 将对应激活顶部子菜单标记为高亮选中状态
								this.tabbarList[i].is_check = true;
							}
						}
					}
				}
				this.$router.push(path);
			},
			selectTabbar(index) {
				for (let idx in this.tabbarList) {
					// 重置子级菜单为待选中状态
					this.tabbarList[idx].is_check = false;
				}
				// 若当前访问路由等于对应子级菜单，则高亮对应的
				this.tabbarList[index].is_check = true;
				this.$router.push(this.tabbarList[index].path);
			},
			logout() {
				// 请求注销token接口
				postLogout().then((res) => {
					// 清空所有缓存
					localStorage.clear();
					// 跳转到登录页
					this._option('/login');
				});
			},
			_option(url , data) {
				this.$router.push({
					path: url,
					query: data
				})
			}
		},
	});
</script>
<style lang="scss" scoped>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
	}

	#menu {
		height: 100%;
	}
    
    .notify1{
        cursor: pointer;
        display: flex;
        
    }

	#main {
		padding: 0 !important;
		min-width: 1160px;
		.main-header{
			padding: 12px;
			.main-tabar{
				// background-color: #f1f1f1;
				background-color: #fff;
				.el-menu-item{
					background-color: unset !important;
					color: #000 !important;
					padding: 0 15px;
				}
				.el-menu.el-menu--horizontal{
					// border-bottom: solid 1px #e6e6e6;
					margin: 0 20px;
					background-color: unset;
				}
				.el-menu--horizontal>.el-menu-item{
					height: 45px;
					line-height: 45px;
				}
				.is-active{
					background-color: unset !important;
					border-bottom: none !important;
				}
				.is-select{
					color: #f03037 !important;
					font-weight: bold !important;
					background-color: unset !important;
					border-bottom: 2px solid #f03037 !important;
				}
			}
		}
	}

	.main-title {
		padding: 18px 24px;

		.arrow {
			--color: #c0c4cc;
			width: 32px;
			display: inline-block;
			transform: translate(-2px, -2px);
		}
	}

	.header {
		height: 100%;
		.fold {
			width: 24px;
			height: 20px;
			border: solid #606266;
			border-width: 1px 0 1px 0;
			&::after {
				content: '';
				position: absolute;
				width: 100%;
				height: 1px;
				background-color: #606266;
				top: calc(49% - 1px);
			}
		}
	}

	img {
		width: 24px;
		height: 24px;
		margin-right: 2px;
	}

	.el-menu-item.is-active {
		background-color: unset !important;
		color: unset !important;

	}
	.el-menu-item.is-select {
		background-color: #f03037 !important;
		color: #fff !important;

	}


	.menu-bg {
		background-color: rgba(240, 48, 55, 0.1);
	}

	// .el-menu-item:hover {
	//     background-color: #f2f5f9 !important;
	// }
	.logo {
		padding: 10px 0;
		border-right: solid 1px #e6e6e6;

		.full {
			width: 128px;
			height: 50px;
			margin-left:2px;
		}
		.thumb{
			width: 50px;
			height: 50px;
			margin-left:2px;
		}
	}


	#menu {
		background-color: #fff;
		z-index: 10;
		bottom: 0;
		margin-top: 0;
		position: fixed;
		top: 64px;
		overflow-x: hidden;
		overflow-y: auto;
		padding-bottom: 80px;
	}

	#menu::-webkit-scrollbar {
		display: none;
		/* Chrome Safari */
	}
</style>
